import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import PageV2 from "components/shared/PageV2";
import { Link } from "react-router-dom";
import { FETCH_ASSESSMENT_CATEGORIES } from "./graphql";

const AssessmentCategoriesPage = () => {
  const { loading, error, data } = useQuery(FETCH_ASSESSMENT_CATEGORIES);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <PageV2 title="Assessment Summary" backTo="./..">
      <div className="grid gap-6 grid-cols-12">
        {data.esgAssessmentCategories.map((category) => (
          <div className="card col-span-3" key={category.id}>
            <Link to={`/assessment/summary/${category.id}`}>
              {category.name}
            </Link>
          </div>
        ))}
      </div>
    </PageV2>
  );
};
export default AssessmentCategoriesPage;
